


interface SmsSendIconProps {
	className?: string,
}


const SmsSendIcon = (props: SmsSendIconProps) => {
	const { className } = props;

	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="custom-sms-send-icon"
			className={`svg-inline--fa fa-custom-sms-send-icon${className ? ` ${className}` : ''}`}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 519 512">
			<path fill="currentColor" d="m37.46,0.02l-16.02,0c-0.99,0 -1.8,0.85 -1.8,1.9l0,17.08c0,0.35 0.4,0.51 0.63,0.26l2.06,-2.31c0.34,-0.38 0.82,-0.6 1.31,-0.6l13.83,0c0.99,0 1.8,-0.85 1.8,-1.9l0,-12.53c0,-1.05 -0.81,-1.9 -1.8,-1.9l-0.01,0zm-12.66,9.68c-0.83,0 -1.51,-0.71 -1.51,-1.59s0.67,-1.59 1.51,-1.59s1.51,0.71 1.51,1.59s-0.67,1.59 -1.51,1.59zm4.64,0c-0.83,0 -1.51,-0.71 -1.51,-1.59s0.67,-1.59 1.51,-1.59s1.51,0.71 1.51,1.59s-0.67,1.59 -1.51,1.59zm4.67,0c-0.83,0 -1.51,-0.71 -1.51,-1.59s0.67,-1.59 1.51,-1.59s1.51,0.71 1.51,1.59s-0.67,1.59 -1.51,1.59z" transform="matrix(26.4203 0 0 26.4203 -518.73 -0.164029)"/>
		</svg>
	);
};

export default SmsSendIcon;